const Truvid = () => {
  let truvidPlaceholder
  let trvInterval = setInterval(() => {
    truvidPlaceholder = document.querySelector('#truvid-ad')
    if (truvidPlaceholder) {
        clearInterval(trvInterval)

        let truvidScript = document.createElement('script')
        let isHomePage = window.location.pathname.split('/').length > 2
        let languageCode = window.location.pathname.split('/')[1]
        let pidMap = {
            he: 12042,
            fr: 12043,
            ar: 12044,
        }

        const pidsToRemove = ['11797', '12042', '12043', '12044']
        pidsToRemove.forEach(pid => {
            const existingScript = document.querySelector(`[data-pid="${pid}"]`)
            if (existingScript) {
                existingScript.remove()
            }
        })

        let truvidContainer = document.querySelector('.trv-player-container')
        if (truvidContainer && truvidContainer.parentElement) {
            truvidContainer.parentElement.remove()
        }

        let pid = pidMap[languageCode] || 11797
        truvidScript.setAttribute('data-pid', pid)
        truvidScript.async = true
        truvidScript.type = 'text/javascript'
        truvidScript.src = !isHomePage ? '//go.trvdp.com/init/15396.js' : '//go.trvdp.com/init/15004.js'
        truvidPlaceholder.appendChild(truvidScript)
    }
  }, 200)

  return <div id="truvid-ad" />
}

export default Truvid
